import React from 'react';
import {Table} from "react-bootstrap";
import {ActionResult} from "../../model";
import LoadingHtml from "../../shared/Loading";
import ErrorPage from "../../shared/ErrorPage";
import {CouponCodeVerifyEntity} from "../../model/CouponCodeVerifyEntity";
import parse from "html-react-parser";

const CouponcodeVerifyList = (props: any) => {
    const submitting: boolean = props.submitting;
    const act: ActionResult = props.action;
    if (submitting) return <LoadingHtml/>
    if (!act) return null;
    if (!act.result) return <ErrorPage msg={act.errorMsg} code={act.errorCode}/>
    const list: CouponCodeVerifyEntity[] = act.data;
    return (
        <Table striped bordered hover>
            <thead>
            <tr>
                <th>#</th>
                <th>쿠폰코드</th>
                <th>검증</th>
            </tr>
            </thead>
            <tbody>
            {
                list.map((item, i) => {
                    const validStr = item.inValid ? `<span class='text-danger'>유효안함</span>` : `<span class='text-primary'>유효함</span>`;
                    return (
                        <tr key={i}>
                            <td>{i + 1}</td>
                            <td>{item.code}</td>
                            <td>
                                {parse(validStr)}
                            </td>
                        </tr>
                    )
                })
            }
            </tbody>
        </Table>
    )
}
export default CouponcodeVerifyList;
